// ** React Imports
import React, { SyntheticEvent, useState, useEffect } from 'react';

// ** MUI Imports
import Wrapper from '../../../components/Wrapper';

import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Alert from '@mui/material/Alert';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'

// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'
import Box from '@mui/material/Box';

import { Link, NavLink, useNavigate } from 'react-router-dom';
import Title from '../../../components/Title';
import axios from "axios";
import CancelIcon from '@mui/icons-material/Cancel';
import { Type_Country } from '../../../models/type_country';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';
import { nowOperationalDateTimeString } from '../../../utils/operationalDateTime';


interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const Offices: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {
  // ** States

  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [type_country_id, setCountry_id] = useState('');
  const [manager, setManager] = useState('');

  const [country, setCountry] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      showLoading();
      try {
        const { data: countryData } = await axios.get("typecountry");
        setCountry(countryData.data);
        await new Promise(resolve => setTimeout(resolve, 2000)); // Esperar 2 segundos
      } catch (error) {
        showAlert('Error fetching data!', 'error');
      } finally {
        hideLoading();
      }

    }
    fetchData();
  }, []);

  const submit = async (event: SyntheticEvent) => {
    event.preventDefault(); // Evita el envío del formulario por defecto
    if (!name || !phone || !address || !city) {
      showAlert('Tiene campos pendientes por diligenciar!', 'warning');
      return;
    }
    const boxDate = nowOperationalDateTimeString();
    const formData = {
      currentDate: boxDate,
      name,
      phone,
      address,
      city,
      manager,
      type_country_id
    }
    const url = '/offices'
    try {
      showLoading();
      const response = await axios.post(url, formData);
      showAlert('Se ha realizado el registro exitosamente!', 'success');
      await new Promise(response => setTimeout(response, 1000));
      navigate('/administrar/oficinas');
    } catch (error) {
      showAlert('Error fetching data!', 'error');
    } finally {
      hideLoading();
    }
  }

  document.title = "Oficinas - Route App";
  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Title>Información Oficinas</Title>
      </Box>
      <Card>
        <Divider sx={{ margin: 0 }} />
        <Box component="form" noValidate onSubmit={submit} sx={{ mt: 1 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField size='small' fullWidth label='Nombre de Oficina' placeholder='Leonard' id="name" onChange={event => setName(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size='small' fullWidth type='tel' label='Teléfono' placeholder='6021234567' id="phone" onChange={event => setPhone(event.target.value)} inputProps={{ maxLength: 10 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size='small' fullWidth label='Dirección' placeholder='Cl 10 45-10' id="address" onChange={event => setAddress(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size='small' fullWidth label='Ciudad' placeholder='Medellín' id="city" onChange={event => setCity(event.target.value)} inputProps={{ maxLength: 30 }} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id='form-layouts-separator-select-label'>Seleccionar País</InputLabel>
                  {country && country.length > 0 ? (
                    <Select
                      label='País'
                      defaultValue=''
                      size='small'
                      id='form-layouts-separator-select'
                      labelId='form-layouts-separator-select-label'
                      onChange={event => setCountry_id(event.target.value)}
                      required
                    >
                      {country.map((country: Type_Country) => {
                        return (
                          <MenuItem key={country.id} value={country.id}>
                            {country.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
          <Divider sx={{ margin: 0 }} />
          <CardActions>
            <Button size='small' type='submit' sx={{ mr: 2 }} variant='contained' onClick={submit}>
              Guardar
            </Button>
            <Link to='/administrar/oficinas'>
              <Button size='small' color='secondary' variant='outlined'>
                Cancel
              </Button>
            </Link>
          </CardActions>
        </Box>
      </Card>

    </HeaderResponsive>
  )
}

export default Offices
